import defaultSearchConfiguration from './default-search-configuration';
import './page/topdata-login-attempt-log-list';
import './page/topdata-login-attempt-log-detail';
import enGB from './snippet/en-GB';
import deDE from './snippet/de-DE';

const { Module } = Shopware;

Module.register('topdata-contact-login-attempt-log', {
    snippets: {
        'en-GB': enGB,
        'de-DE': deDE,
    },
    type: 'plugin',
    name: 'TopdataContactLoginSW6.loginLog.module.name',
    title: 'TopdataContactLoginSW6.loginLog.module.title',
    description: 'TopdataContactLoginSW6.loginLog.module.description',
    color: '#ff5722',
    icon: 'regular:sign-in',

    entity: 'tdcl_login_attempt_log',

    routes: {
        list: {
            component: 'topdata-login-attempt-log-list',
            path: 'list',
        },
        detail: {
            component: 'topdata-login-attempt-log-detail',
            path: 'detail/:id',
        },
    },

    navigation: [{
        id: 'topdata-contact-login-attempt-log',
        label: 'TopdataContactLoginSW6.loginLog.module.title',
        color: '#ff5722',
        icon: 'regular:sign-in',
        path: 'topdata.contact.login.attempt.log.list',
        parent: 'sw-customer',
        position: 120,
    }],

    defaultSearchConfiguration,
});
